import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../../store/ui-slice";
import ReportCustomerFreeProductMain from "../../../features/report/report-customer-free-product/component/ReportCustomerFreeProductMain";

const title = "Report Customer Free Product";

const ReportCustomerFreeProductPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <ReportCustomerFreeProductMain />;
};

export default ReportCustomerFreeProductPage;
